import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function NewsletterBand() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Merci, vous êtes bien inscrite ✿");
      setEmail("");
    } catch {
      toast.error("Une erreur est survenue");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-berulia-rose/40 py-20 md:py-24 px-6 border-t border-berulia-rosedeep/20">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-4xl md:text-5xl text-berulia-inkdeep">
          Newsletter
        </h2>
        <p className="mt-4 text-berulia-inkmuted text-sm md:text-base leading-relaxed">
          Nouveautés, ventes privées, inspirations.
        </p>
        <form
          onSubmit={subscribe}
          data-testid="newsletter-band-form"
          className="mt-8 flex max-w-md mx-auto border-b border-berulia-inkdeep/30 pb-2"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.com"
            data-testid="newsletter-band-input"
            className="bg-transparent flex-1 outline-none placeholder:text-berulia-inkmuted/60 text-sm py-2"
          />
          <button
            disabled={busy}
            data-testid="newsletter-band-submit"
            className="overline text-berulia-rosedeep hover:text-berulia-inkdeep transition px-3"
          >
            {busy ? "..." : "S'inscrire →"}
          </button>
        </form>
      </div>
    </section>
  );
}
